import { Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActionMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    boxShadow: theme.customShadows.dropdown,
    border: '1px solid',
    borderColor: theme.palette.divider,
  },
}));

/** Row action in an ActionMenu; `destructive` swaps the brand hover fill for the error one. */
export const ActionMenuItem = styled(MenuItem, {
  shouldForwardProp: prop => prop !== 'destructive',
})<{ destructive?: boolean }>(({ theme, destructive = false }) => {
  const tone = destructive ? theme.palette.error : theme.palette.primary;
  return {
    gap: theme.spacing(1),
    ...(destructive && { color: theme.palette.error.main }),
    '&:hover': { backgroundColor: tone.light, color: tone.contrastText },
  };
});
